<header>
  <div class="row">
    <nav class="top-bar" data-topbar="">
      <ul class="title-area">
        <li class="name">
          <h1>
            <a target="_blank" [routerLink]="['/']">
              <img class="logo" src="../assets/images/logo.png" />
              <img class="mini-logo" src="../assets/images/mini-logo.png" />
            </a>
          </h1>
        </li>
        <li class="toggle-topbar menu-icon">
          <a (click)="toggleMenu()"><span></span></a>
        </li>
        <!-- <li class="mobile-lang"><a href="http://aban.net/en" i18n>En</a></li> -->
      </ul>

      <section class="top-bar-section">
        <!-- Left Nav Section -->
        <ul class="left">
          <li class="tools">
            <!-- <div class="search">
                            <i class="fa fa-search"></i>
                            <form action="https://aban.net" method="get">
                                <input name="s" type="text" i18n-placeholder placeholder="جستـجو">
                                <input type="submit" value="">
                            </form>
                        </div> -->
            <div class="language">
              <!-- <a i18n href="http://aban.net/en/">
                                En
                            </a> -->
            </div>
          </li>
          <li class="header-buttons">
            <div>
              <!-- <a target="_blank" [routerLink]="['/aban/support']" class="button white-button"
                >پشتیبانی مشتریان</a
              > -->
              <a
                target="_blank"
                href="https://ehraz.aban.net/"
                class="button red-button"
                >سامانه افتتاح حساب</a
              >
            </div>
          </li>
          <!-- MENU -->
          <li class="has-dropdown hide-for-medium-up lvl1 not-click" #menuItem1>
            <!-- RESPONSIVE -->
            <a href="javascript:void(0)" i18n>آبان</a>
            <ul class="dropdown">
              <li class="title back js-generated">
                <h5><a href="javascript:void(0)"></a></h5>
              </li>
              <li class="parent-link hide-for-medium-up">
                <a
                  class="parent-link js-generated"
                  href="javascript:void(0)"
                  i18n
                  >آبان</a
                >
              </li>
              <!-- IF HAS CHILD -->
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)" i18n>آشنایی با آبان</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      i18n
                      >آشنایی با آبان</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/about-us']" i18n>درباره ما</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/our-services/']" i18n>خدمات ما</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/awards/']" i18n>افتخارات ما</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/licenses']" i18n>مجوزهای آبان</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)" i18n>ارتباط با آبان</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      i18n
                      >ارتباط با آبان</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/offices']" i18n>دفاتر آبان</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/contact-us']" i18n>تماس با آبان</a>
                  </li>
                  <!-- RED -->
                  <!-- <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/support']" i18n
                      >پشتیبانی مشتریان</a
                    >
                  </li> -->
                  <!-- RED -->
                  <li class="lvl3">
                    <a
                      i18n
                      [routerLink]="['/aban/support/complaints']"
                      [queryParams]="{ title: 'شکایات' }"
                      >شکایات</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/social-networks']" i18n
                      >شبکه‌های اجتماعی</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)" i18n>همکاری با آبان</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      i18n
                      >همکاری با آبان</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/job-opportunities']" i18n
                      >فرصت‌های شغلی</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/cooperation-request']" i18n
                      >پیشنهاد همکاری با آبان</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)" i18n>پرداخت به آبان</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      i18n
                      >پرداخت به آبان</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/bank-accounts']" i18n
                      >شماره حساب‌های بانکی</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
            </ul>
          </li>
          <li class="show-for-medium-up" >
            <!-- DESKTOP-->
            <a
              href="javascript:void(0)"
              data-dropdown="mega-menu-1"
              data-options="is_hover:true"
              aria-expanded="false"
              i18n
              >آبان</a
            >
            <!-- megamenu IDs should change.  -->
            <div
              id="mega-menu-1"
              data-dropdown-content=""
              class="large f-dropdown content row f-open-dropdown"
            >
              <!-- ID should change -->
              <div class="medium-3 columns">
                <h6><a href="javascript:void(0)" i18n>آشنایی با آبان</a></h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/about-us']" i18n>درباره ما</a>
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/our-services']" i18n>خدمات ما</a>
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/awards']" i18n>افتخارات ما</a>
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/licenses']" i18n>مجوزهای آبان</a>
                  </li>
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6><a href="javascript:void(0)" i18n>ارتباط با آبان</a></h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/offices']" i18n>دفاتر آبان</a>
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/contact-us']" i18n>تماس با آبان</a>
                  </li>
                  <!-- <li>
                    <a target="_blank" [routerLink]="['/aban/support']" i18n
                      >پشتیبانی مشتریان</a
                    >
                  </li> -->
                  <li>
                    <a
                      i18n
                      [routerLink]="['/aban/support/complaints']"
                      [queryParams]="{ title: 'شکایات' }"
                      >شکایات</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/social-networks']" i18n
                      >شبکه‌های اجتماعی</a
                    >
                  </li>
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6><a href="javascript:void(0)" i18n>همکاری با آبان</a></h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/job-opportunities']" i18n
                      >فرصت‌های شغلی</a
                    >
                  </li>
                  <li>
                    <a routerLink="/aban/cooperation-request" i18n
                      >پیشنهاد همکاری با آبان</a
                    >
                  </li>
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6><a href="javascript:void(0)" i18n>پرداخت به آبان</a></h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['/aban/bank-accounts']" i18n
                      >شماره حساب‌های بانکی</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li class="has-dropdown hide-for-medium-up lvl1 not-click" #menuItem1>
            <!-- RESPONSIVE -->
            <a href="javascript:void(0)" i18n>خدمات</a>
            <ul class="dropdown">
              <li class="title back js-generated">
                <h5><a href="javascript:void(0)"></a></h5>
              </li>
              <li class="parent-link hide-for-medium-up">
                <a
                  class="parent-link js-generated"
                  href="javascript:void(0)"
                  i18n
                  >خدمات</a
                >
              </li>
              <!-- IF HAS CHILD -->
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)" i18n>پلتفرم های معاملاتی</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      [routerLink]="['/aban/our-services/trading-platforms']"
                      i18n
                      >پلتفرم های معاملاتی</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/online-plus']" i18n
                      >آنلاین پلاس</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/hamrah-plus']" i18n
                      >همراه پلاس</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/offline-orders']" i18n
                      >ثبت سفارشات اینترنتی</a
                    >
                  </li>
                  <!-- RED -->
                  <!-- <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/mobile-trader-gold']" i18n
                      >همراه تریدر معاملات آتی</a
                    >
                  </li> -->
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/online-system-gold']" i18n
                      >سامانه آنلاین معاملات آتی</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/sell-edalat']" i18n
                      >سامانه فروش سهام عدالت</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)" i18n>مدیریت سرمایه گذاری</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      [routerLink]="[
                        '/aban/our-services/modiriyat-sarmayeh-gozari'
                      ]"
                      target="_blank"
                      i18n
                      >مدیریت سرمایه گذاری</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a
                      [routerLink]="[
                        '/services/dedicated-investment-management'
                      ]"
                      i18n
                      target="_blank"
                      >مدیریت اختصاصی سرمایه گذاری</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a
                      [routerLink]="['/services/management-investment-funds']"
                      i18n
                      target="_blank"
                      >مدیریت صندوق های سرمایه گذاری</a
                    >
                  </li>
                  <!-- RED -->
                  <!-- <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/didgah-aban']" i18n
                      >سامانه تحلیلی دیدگاه آبان</a
                    >
                  </li> -->
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)" i18n>صندوق های سرمایه گذاری</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a class="parent-link js-generated" i18n
                      >صندوق های سرمایه گذاری</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/kousar-fund']" i18n
                      >صندوق کوثر یکم</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/yekom-fund']" i18n
                      >صندوق یکم آبان</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/pars-fund']" i18n
                      >صندوق پارس</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/omid-fund']" i18n
                      >صندوق ندای امید</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/sustainable-growth-fund']" i18n
                      >صندوق رشد پایدار</a
                    >
                  </li>
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)" i18n>کالا و انرژی</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      [routerLink]="['/services/products']"
                      i18n
                      >کالا و انرژی</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/commodity-transactions']" i18n
                      >معاملات کالا</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/services/energy-transactions']" i18n
                      >معاملات انرژی</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a
                      [routerLink]="[
                        'services/acceptance-goods-energy-exchange'
                      ]"
                      i18n
                      target="_blank"
                      >پذیرش کالا ها در بورس</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
            </ul>
          </li>
          <li class="show-for-medium-up">
            <!-- DESKTOP-->
            <a
              href="javascript:void(0)"
              data-dropdown="mega-menu-2"
              data-options="is_hover:true"
              aria-expanded="false"
              class=""
              i18n
              >خدمات</a
            >
            <!-- megamenu IDs should change.  -->
            <div
              id="mega-menu-2"
              data-dropdown-content=""
              class="large f-dropdown content row"
              style="position: absolute; left: -99999px; top: 48px"
              aria-hidden="true"
            >
              <!-- ID should change -->
              <div class="medium-3 columns">
                <h6>
                  <a target="_blank" [routerLink]="['/aban/our-services/trading-platforms']" i18n
                    >پلتفرم های معاملاتی</a
                  >
                </h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['services/online-plus']" i18n
                      >آنلاین پلاس</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['services/hamrah-plus']" i18n
                      >همراه پلاس</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['services/offline-orders']" i18n
                      >ثبت سفارشات اینترنتی</a
                    >
                  </li>
                  <!-- <li>
                    <a target="_blank" [routerLink]="['services/mobile-trader-gold']" i18n
                      >همراه تریدر معاملات آتی</a
                    >
                  </li> -->
                  <li>
                    <a target="_blank" [routerLink]="['services/online-system-gold']" i18n
                      >سامانه آنلاین معاملات آتی</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['services/sell-edalat']" i18n
                      >سامانه فروش سهام عدالت</a
                    >
                  </li>
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6 routerLink="/aban/our-services/modiriyat-sarmayeh-gozari">
                  <a i18n>مدیریت سرمایه گذاری</a>
                </h6>
                <ul>
                  <li>
                    <a
                      [routerLink]="[
                        '/services/dedicated-investment-management'
                      ]"
                      i18n
                      target="_blank"
                      >مدیریت اختصاصی سرمایه گذاری</a
                    >
                  </li>
                  <li>
                    <a
                      [routerLink]="['/services/management-investment-funds']"
                      i18n
                      target="_blank"
                      >مدیریت صندوق های سرمایه گذاری</a
                    >
                  </li>
                  <!-- <li>
                    <a target="_blank" [routerLink]="['/services/didgah-aban']" i18n
                      >سامانه تحلیلی دیدگاه آبان</a
                    >
                  </li> -->
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6>
                  <a routerLink="/services/sandoghe-sarmaye-gozari" i18n
                    >صندوق های سرمایه گذاری</a
                  >
                </h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['/services/kousar-fund']" i18n
                      >صندوق کوثر یکم</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/services/yekom-fund']" i18n
                      >صندوق یکم آبان</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/services/pars-fund']" i18n
                      >صندوق پارس</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/services/omid-fund']" i18n
                      >صندوق ندای امید</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/services/sustainable-growth-fund']" i18n
                      >صندوق رشد پایدار</a
                    >
                  </li>
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6>
                  <a routerLink="/services/products" i18n>کالا و انرژی</a>
                </h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['/services/commodity-transactions']" i18n
                      >معاملات کالا</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/services/energy-transactions']" i18n
                      >معاملات انرژی</a
                    >
                  </li>
                  <li>
                    <a
                      [routerLink]="[
                        'services/acceptance-goods-energy-exchange'
                      ]"
                      target="_blank"
                      i18n
                      >پذیرش کالا ها در بورس</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li class="has-dropdown hide-for-medium-up lvl1 not-click" #menuItem1>
            <!-- RESPONSIVE -->
            <a href="javascript:void(0)">آموزش</a>
            <ul class="dropdown">
              <li class="title back js-generated">
                <h5><a href="javascript:void(0)"></a></h5>
              </li>
              <li class="parent-link hide-for-medium-up">
                <a class="parent-link js-generated" href="javascript:void(0)"
                  >آموزش</a
                >
              </li>
              <!-- IF HAS CHILD -->
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">دانستنی‌های بورسی</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      >دانستنی‌های بورسی</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['training/basics-investing-stock-market']"
                      >مبانی سرمایه گذاری در بورس</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['training/exchange-traded-instruments']"
                      >ابزارهای قابل معامله در بورس</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['training/mutual-funds']"
                      >صندوق های سرمایه گذاری مشترک</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/training/other-funds']">سایر صندوق ها</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/training/saham-edalat']">سهام عدالت</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/training/etf-funds']"
                      >صندوق های قابل معامله دولتی</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['training/option-future-contracts']"
                      >قراردادهای آتی و اختیار معامله</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">منابع آموزشی</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      >منابع آموزشی</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['training/course-videos']"
                      >فیلم های آموزشی</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['training/manuals']">دفترچه های راهنما</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">ورود به بورس</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      >ورود به بورس</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['training/start-point']">نقطه شروع</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>
            </ul>
          </li>
          <li class="show-for-medium-up">
            <!-- DESKTOP-->
            <a
              href="javacript:void(0)"
              data-dropdown="mega-menu-3"
              data-options="is_hover:true"
              aria-expanded="false"
              >آموزش</a
            >
            <!-- megamenu IDs should change.  -->
            <div
              id="mega-menu-3"
              data-dropdown-content=""
              class="large f-dropdown content row"
            >
              <!-- ID should change -->
              <div class="medium-4 columns">
                <h6><a href="javascript:void(0)">دانستنی‌های بورسی</a></h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['training/basics-investing-stock-market']"
                      >مبانی سرمایه گذاری در بورس</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['training/exchange-traded-instruments']"
                      >ابزارهای قابل معامله در بورس</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['training/mutual-funds']"
                      >صندوق های سرمایه گذاری مشترک</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['training/other-funds']">سایر صندوق ها</a>
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['training/saham-edalat']">سهام عدالت</a>
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['training/etf-funds']"
                      >صندوق های قابل معامله دولتی</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['training/option-future-contracts']"
                      >قراردادهای آتی و اختیار معامله</a
                    >
                  </li>
                </ul>
              </div>
              <div class="medium-4 columns">
                <h6><a href="javascript:void(0)">منابع آموزشی</a></h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['training/course-videos']"
                      >فیلم های آموزشی</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['training/manuals']">دفترچه های راهنما</a>
                  </li>
                </ul>
              </div>
              <div class="medium-4 columns">
                <h6><a href="javascript:void(0)">ورود به بورس</a></h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['training/start-point']">نقطه شروع</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li class="has-dropdown hide-for-medium-up lvl1 not-click" #menuItem1>
            <!-- RESPONSIVE -->
            <a href="javascript:void(0)">مشتریان</a>
            <ul class="dropdown">
              <li class="title back js-generated">
                <h5><a href="javascript:void(0)"></a></h5>
              </li>
              <li class="parent-link hide-for-medium-up">
                <a class="parent-link js-generated" href="javascript:void(0)"
                  >مشتریان</a
                >
              </li>
              <!-- IF HAS CHILD -->
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">امور مشتریان</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      >امور مشتریان</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/customers/services/how-to-register']"
                      >افتتاح حساب</a
                    >
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/customers/services/investing-in-funds']"
                      >سرمایه‌گذاری در صندوق ها</a
                    >
                  </li>
                  <!-- RED -->
                  <!-- <li class="lvl3"><a href="https://booking.aban.net">سامانه نوبت دهی</a>
                                    </li> -->
                  <!-- RED -->
                  <!-- <li class="lvl3">
                    <a target="_blank" [routerLink]="['/aban/support']">پشتیبانی مشتریان</a>
                  </li> -->
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/customers/help']">راهنمای مشتریان</a>
                  </li>
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/customers/pro-investors']">سرمایه‌گذاران حرفه‌ای</a>
                  </li>
                  <li class="lvl3">
                    <a target="_blank" [routerLink]="['/customers/deceased-edalat']">سهام عدالت متوفیان</a>
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">اوراق بهادار</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      >اوراق بهادار</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" href="http://c.aban.net">حساب من</a>
                  </li>
                  <!-- RED -->
                  <li class="lvl3">
                    <a target="_blank" href="http://online.aban.net/"
                      >پلتفرم های معاملات اوراق</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">معاملات آتی و کالا</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      >معاملات آتی و کالا</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" href="http://gold.aban.net"
                      >سامانه آنلاین آتی</a
                    >
                  </li>
                  <li class="lvl3">
                    <a target="_blank" href="http://aban.ebgo.ir/Login"
                      >سامانه ثبت نام و خرید بورس کالا</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
              <li #menuItem2 class="lvl2 has-dropdown not-click">
                <a href="javascript:void(0)">مدیریت سرمایه‌گذاری</a>
                <ul class="dropdown">
                  <li class="title back js-generated">
                    <h5><a href="javascript:void(0)"></a></h5>
                  </li>
                  <li class="parent-link hide-for-medium-up">
                    <a
                      class="parent-link js-generated"
                      href="javascript:void(0)"
                      >مدیریت سرمایه‌گذاری</a
                    >
                  </li>
                  <!-- IF HAS CHILD -->
                  <li class="lvl3">
                    <a target="_blank" href="http://portfolio.aban.net"
                      >سبد گردانی</a
                    >
                  </li>
                  <!-- RED -->
                </ul>
              </li>
            </ul>
          </li>
          <li class="show-for-medium-up">
            <!-- DESKTOP-->
            <a
              href="javascript:void(0)"
              data-dropdown="mega-menu-4"
              data-options="is_hover:true"
              aria-expanded="false"
              >مشتریان</a
            >
            <!-- megamenu IDs should change.  -->
            <div
              id="mega-menu-4"
              data-dropdown-content=""
              class="large f-dropdown content row"
            >
              <!-- ID should change -->
              <div class="medium-3 columns">
                <h6><a href="javascript:void(0)">امور مشتریان</a></h6>
                <ul>
                  <li>
                    <a target="_blank" [routerLink]="['/customers/services/how-to-register']"
                      >افتتاح حساب</a
                    >
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/customers/services/investing-in-funds']"
                      >سرمایه‌گذاری در صندوق ها</a
                    >
                  </li>
                  <!-- <li><a href="https://booking.aban.net">سامانه نوبت دهی</a></li> -->
                  <!-- <li>
                    <a target="_blank" [routerLink]="['/aban/support']">پشتیبانی مشتریان</a>
                  </li> -->
                  <li>
                    <a target="_blank" [routerLink]="['/customers/help']">راهنمای مشتریان</a>
                  </li>
                   <li>
                    <a target="_blank" [routerLink]="['/customers/pro-investors']">سرمایه‌گذاران حرفه‌ای</a>
                  </li>
                  <li>
                    <a target="_blank" [routerLink]="['/customers/deceased-edalat']">سهام عدالت متوفیان</a>
                  </li>
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6><a href="javascript:void(0)">اوراق بهادار</a></h6>
                <ul>
                  <li>
                    <a target="_blank" href="http://c.aban.net">حساب من</a>
                  </li>
                  <li>
                    <a target="_blank" href="http://online.aban.net/"
                      >پلتفرم های معاملات اوراق</a
                    >
                  </li>
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6><a href="javascript:void(0)">معاملات آتی و کالا</a></h6>
                <ul>
                  <li>
                    <a target="_blank" href="http://gold.aban.net"
                      >سامانه آنلاین آتی</a
                    >
                  </li>
                  <li>
                    <a target="_blank" href="http://aban.ebgo.ir/Login"
                      >سامانه ثبت نام و خرید بورس کالا</a
                    >
                  </li>
                </ul>
              </div>
              <div class="medium-3 columns">
                <h6><a href="javascript:void(0)">مدیریت سرمایه‌گذاری</a></h6>
                <ul>
                  <li>
                    <a target="_blank" href="http://portfolio.aban.net"
                      >سبد گردانی</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </nav>
    <!-- End Header and Nav -->
  </div>
</header>
